import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { Node_Type } from 'ricos-schema';
import { Loader, MediaItemErrorMsg } from 'wix-rich-content-ui-components';
import { getImageClickActionConfig } from '../viewer/get-image-click-action-config.js';
import { Image } from '../viewer/image.js';
import { EditorImageCaption } from './editor-image-caption.js';
import 'classnames';
import '../image-viewer.rtlignore-dde44699.js';
import '../style-inject.es-746bb8ed.js';
import '../consts.js';
import '../icons/expand.js';
import '../viewer/image-container.js';
import '../dataHooks.js';
import '../viewer/use-custom-width-style.js';
import '../viewer/use-fallback-width-style.js';
import '../viewer/use-image-dimensions.js';
import '../viewer/use-image-social-attributes.js';
import 'lodash';
import '../InPluginInput.js';

const EditorImage = ({ updateAttributes, node }) => {
  var _a, _b;
  const { t, isMobile } = useContext(RicosContext);
  const { loading, loadingPercentage, error, tempData } = node.attrs;
  const onCaptionChange = (caption) => {
    updateAttributes({ caption });
  };
  const { src } = node.attrs.image || {};
  const shouldRender = !!tempData || (src == null ? void 0 : src.url) || (src == null ? void 0 : src.id);
  const ricosNode = {
    imageData: node.attrs,
    id: node.attrs.id,
    type: Node_Type.IMAGE,
    nodes: []
  };
  const imageClickActionConfig = getImageClickActionConfig({
    imageData: ricosNode.imageData
  });
  return shouldRender ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Image,
    {
      isMobile,
      node: ricosNode,
      dataUrl: tempData,
      imageClickActionConfig: { type: "regular" },
      shouldLazyLoadImages: false,
      captionComponent: /* @__PURE__ */ React.createElement(
        EditorImageCaption,
        {
          onCaptionChange,
          imageType: imageClickActionConfig.type,
          caption: (_b = (_a = ricosNode.imageData) == null ? void 0 : _a.caption) != null ? _b : ""
        }
      )
    }
  ), loading && /* @__PURE__ */ React.createElement(Loader, { type: "medium", percent: loadingPercentage }), error && /* @__PURE__ */ React.createElement(MediaItemErrorMsg, { error, t })) : null;
};

export { EditorImage };
//# sourceMappingURL=component.js.map
